import { useDispatch, useSelect } from '@wordpress/data';
import { useEffect, useState } from '@wordpress/element';
import { __ } from '@wordpress/i18n';
import attributes from './attributes';
import classnames from 'classnames';
import { DeliveryStepHeading } from './components/delivery-step-heading';
import { withFilteredAttributes } from './shared/hocs';
import { useDeliveryDate } from './base/context/hooks/use-delivery-date';
import Block from './block';
import {settings} from "@lapilli-ui/date";

const FrontendBlock = ( {
	title,
	showStepNumber,
	className,
	checkoutExtensionData,
} ) => {
	const divClassName = classnames(
		'wc-block-components-checkout-step',
		className,
		{
			'wc-block-components-checkout-step--with-step-number':
				showStepNumber,
		}
	);

	const {
		carrierOptions,
		availableDates,
		availableSlots,
		minDate,
		maxDate,
		selectedCarrier,
		selectedDate,
		selectedSlot,
		isRequired,
		selectedProcessingMethod,
		isInitialized,
		removeFee,
		changeStatus,
	} = useDeliveryDate();


	const { setExtensionData } = checkoutExtensionData;

	console.log(checkoutExtensionData);
	const { setValidationErrors, clearValidationError } = useDispatch(
		'wc/store/validation'
	);

	useEffect( () => {
		if ( isInitialized ) {

			removeFee();

			setExtensionData(
				'ywcdd/delivery-date',
				'ywcdd_carrier_id',
				'' + selectedCarrier
			);
			setExtensionData(
				'ywcdd/delivery-date',
				'ywcdd_date',
				selectedDate
			);
			setExtensionData(
				'ywcdd/delivery-date',
				'ywcdd_slot_id',
				selectedSlot
			);
			setExtensionData(
				'ywcdd/delivery-date',
				'ywcdd_processing_id',
				'' + selectedProcessingMethod
			);
			setExtensionData(
				'ywcdd/delivery-date',
				'ywcdd_has_slot',
				availableSlots.length > 0
			);
		}
	}, [ isInitialized, selectedCarrier ] );

	const { carrierError, dateError, slotError } = useSelect( ( select ) => {
		const store = select( 'wc/store/validation' );
		return {
			carrierError: store.getValidationError( 'ywcdd_carrier' ),
			dateError: store.getValidationError( 'ywcdd_date' ),
			slotError: store.getValidationError( 'ywcdd_slot' ),
		};
	} );

	const errorExist = ( error ) => {
		return !! error?.message && ! error?.hidden;
	};

	const isDateRequired = () => {
		return isRequired || selectedCarrier !== '-1';
	};
	const { hasError } = useSelect( ( select ) => {
		const store = select( 'wc/store/checkout' );
		const isBefore = store.isBeforeProcessing();
		let formError =
			errorExist( carrierError ) ||
			errorExist( dateError ) ||
			errorExist( slotError );

		if ( isBefore ) {
			if ( isRequired && '-1' === selectedCarrier ) {
				if ( ! errorExist( carrierError ) ) {
					setValidationErrors( {
						ywcdd_carrier: {
							message: __(
								'Please set a carrier',
								'yith-woocommerce-delivery-date'
							),
							hidden: false,
						},
					} );
				}
				formError = true;
			}
			if (
				isDateRequired() &&
				( '' === selectedDate || null === selectedDate )
			) {
				if ( ! errorExist( dateError ) ) {
					setValidationErrors( {
						ywcdd_date: {
							message: __(
								'Please set a delivery date',
								'yith-woocommerce-delivery-date'
							),
							hidden: false,
						},
					} );
				}
				formError = true;
			}
			if (
				isRequired &&
				availableSlots.length > 0 &&
				'-1' === selectedSlot
			) {
				if ( ! errorExist( slotError ) ) {
					setValidationErrors( {
						ywcdd_slot: {
							message: __(
								'Please set a time slot',
								'yith-woocommerce-delivery-date'
							),
							hidden: false,
						},
					} );
				}
				formError = true;
			}
		}
		return {
			hasError: formError,
		};
	} );

	useEffect( () => {
		if ( ! hasError ) {
			clearValidationError( 'ywcdd_carrier' );
			clearValidationError( 'ywcdd_date' );
			clearValidationError( 'ywcdd_slot' );
		}
	}, [ hasError, clearValidationError ] );

	const clearError = ( eventType, value ) => 	{

		if ( 'carrier' === eventType && value !== '' ) {
			if ( errorExist( carrierError ) ) {
				clearValidationError( 'ywcdd_carrier' );
			}

			setExtensionData(
				'ywcdd/delivery-date',
				'ywcdd_carrier_id',
				'' + value
			);
		}

		if ( 'date' === eventType && value !== '' ) {
			if ( errorExist( dateError ) ) {
				clearValidationError( 'ywcdd_date' );
			}

			const date = settings.formatDate('Y-m-d', value);

			setExtensionData(
				'ywcdd/delivery-date',
				'ywcdd_date',
				date
			);
		}

		if ( 'slot' === eventType && value !== '' ) {
			if ( errorExist( slotError ) ) {
				clearValidationError( 'ywcdd_slot' );
			}
			setExtensionData( 'ywcdd/delivery-date', 'ywcdd_slot_id', value );
			setExtensionData(
				'ywcdd/delivery-date',
				'ywcdd_has_slot',
				availableSlots.length > 0
			);
		}
		changeStatus( eventType, value );
	};
	if ( carrierOptions.length === 0 ) return null;
	return (
		<fieldset className={ divClassName }>
			<DeliveryStepHeading>{ title }</DeliveryStepHeading>
			<div className="wc-block-components-checkout-step__container">
				<div className="wc-block-components-checkout-step__content">
					<Block
						carrierOptions={ carrierOptions }
						availableDates={ availableDates }
						minDate={ minDate }
						maxDate={ maxDate }
						selectedCarrier={ selectedCarrier }
						selectedDate={ selectedDate }
						selectedSlot={ selectedSlot }
						availableSlots={ availableSlots }
						isRequired={ isRequired }
						carrierValidationError={ carrierError }
						dateValidationError={ dateError }
						slotValidationError={ slotError }
						onChange={ clearError }
					/>
				</div>
			</div>
		</fieldset>
	);
};

export default withFilteredAttributes( attributes )( FrontendBlock );
